import mPostCard2 from "../Card/PostCard2.vue";
import mPostCard911 from "../Card/PostCard911.vue";
import mPostCard912 from "../Card/PostCard912.vue";
import mPostCard914 from "../Card/PostCard914.vue";
import mPostCard915 from "../Card/PostCard915.vue";
import mPostCard916 from "../Card/PostCard916.vue";
import mPostCard919 from "../Card/PostCard919.vue";
import mPostCard920 from "../Card/PostCard920.vue";
import mPostCard921 from "../Card/PostCard921.vue";
import mPostCard310 from "../Card/PostCard310.vue";

export const Cards = {
    mPostCard2,
    mPostCard911,
    mPostCard912,
    mPostCard914,
    mPostCard915,
    mPostCard916,
    mPostCard919,
    mPostCard920,
    mPostCard921,
    mPostCard310,
}